// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox-eff40995"};